import Icon from 'src/components/atoms/icon'

import { useState } from 'react'
import { useUserStore } from 'src/stores'
import { useTranslation } from 'react-i18next'
import { useAuthContext } from 'src/auth/hooks'
import { getNameInitials } from 'src/utils/function'

import {
  Flex,
  Avatar,
  Button,
  Divider,
  Popover,
  Tooltip,
  Typography,
} from 'antd'

function UserMenuNew() {
  const { user } = useUserStore()
  const { i18n } = useTranslation()
  const { logout } = useAuthContext()

  const [showMenu, setShowMenu] = useState(false)

  const handleLogout = () => logout()

  return (
    <Flex className="ml-2" data-testid="user-menu">
      <Popover
        open={showMenu}
        trigger="click"
        placement="bottomRight"
        onOpenChange={(state) => setShowMenu(state)}
        content={
          <Flex vertical className="min-w-[200px] max-w-[250px]" gap="small">
            <Flex gap="middle">
              <Avatar size={40} className="min-w-[40px] bg-primary">
                {getNameInitials(user?.userName ?? '-')}
              </Avatar>
              <Flex vertical className="flex-1 overflow-hidden">
                <Typography.Text className="font-bold" ellipsis>
                  {user?.userName}
                </Typography.Text>
                <Tooltip title={user?.email}>
                  <Typography.Text className="text-xs" ellipsis>
                    {user?.email}
                  </Typography.Text>
                </Tooltip>
              </Flex>
            </Flex>
            <Divider className="my-0 py-0" />

            <Button
              type="text"
              onClick={handleLogout}
              icon={<Icon name="LogOut" />}
              className="justify-start"
            >
              {i18n.t('userMenu.logout')}
            </Button>
          </Flex>
        }
      >
        <Button
          className="border-none bg-transparent"
          shape="circle"
          onClick={() => {
            if (!showMenu) {
              setShowMenu(true)
            }
          }}
          icon={
            <Avatar size={40} className="bg-primary hover:border-warning">
              {getNameInitials(user?.userName ?? '-')}
            </Avatar>
          }
        />
      </Popover>
    </Flex>
  )
}

export default UserMenuNew
